/**
 * Tom do `Badge outline` para rótulos de tier (conta ou oportunidade).
 *
 * Convenção do design system: apenas o tier mais alto ("Enterprise") recebe
 * destaque de acento; qualquer outro rótulo usa o tom neutro. Ponto único —
 * antes duplicado como `tierBadgeTone` em `KanbanBoard.tsx` (pipeline
 * comercial) e como réplica local em `AccountList.tsx` (achado do B2).
 */
export function tierBadgeTone(tier) {
    return tier === "Enterprise" ? "accent" : "neutral";
}
//# sourceMappingURL=tierBadgeTone.js.map